import { createAction } from '@reduxjs/toolkit'

export const setInitialFilterInfo = createAction('common/setInitialFilterInfo')
export const setCurrentFilterInfo = createAction('common/setCurrentFilterInfo')
export const resetTimeFilters = createAction('common/resetTimeFilters')
export const updateTimeFilters = createAction('common/updateTimeFilters')
export const fullListingsReceived = createAction('common/fullListingsReceived')
